import { keys } from 'ramda';
import React from 'react';
import styled, { css } from 'styled-components';
import OverflowScrollWrapper from '~/components/molecule/OverflowScrollWrapper';
import useCurrentBreakpoint from '~/hooks/useCurrentBreakpoint';
import TEST_ID from './index.testid';

import KenmerkGroup from '../KenmerkGroup';
import type { RealworksRelatieSyncType } from '~/graphql/types';
import type { Kenmerk, KenmerkLookup } from '../Synchronization/types';

export type Props = {
  kenmerkLookup: KenmerkLookup;
  selectable?: boolean;
  syncType: RealworksRelatieSyncType;
  onChange: (args: { groupName: string; kenmerkList: Array<Kenmerk> }) => void;
};

const RealworksSelectableAccordion: React.FCC<Props> = ({
  dataTestId,
  kenmerkLookup,
  onChange,
  syncType,
  selectable = true,
  ...rest
}) => {
  const groupNames = keys(kenmerkLookup);
  const currentBp = useCurrentBreakpoint();

  return (
    <Container data-testid={dataTestId} {...rest}>
      <OverflowScrollWrapper
        style={{ maxHeight: currentBp === 'mobile' ? '100vh' : '50vh' }}
      >
        {groupNames.map((name: string) => (
          <KenmerkGroup
            key={`key-${name}`}
            kenmerken={kenmerkLookup[name]}
            name={name}
            onChange={({ kenmerkList }) =>
              onChange({ groupName: name, kenmerkList })
            }
            dataTestId={TEST_ID.KENMERK_GROUP}
            selectable={selectable}
            syncType={syncType}
          />
        ))}
      </OverflowScrollWrapper>
    </Container>
  );
};

const Container = styled.div<{}>(
  ({ theme }) => css`
    ${theme.mq.lessThan('mobile')`
      margin: ${theme.space('l')} 0;
    `}
  `,
);

export default RealworksSelectableAccordion;
